<div class="flex flex-col gap-3">
  <span
    class="bg-red-4 font-roboto-500 text-16 rounded-5 p-5 text-grey-1 max-sm:text-13 max-sm:p-3"
  >
    {{ this.title() }}
  </span>
  <div class="flex justify-between gap-5">
    <div class="flex flex-col flex-grow gap-5">
      <div class="flex gap-2 items-center">
        <img
          alt="photo"
          class="flex-shrink-0 w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15"
          [src]="getHomeImageUrl()"
        />
        <span
          class="font-roboto-600 max-sm:text-10 text-14 truncate whitespace-nowrap overflow-hidden text-ellipsis flex-grow w-0"
        >
          {{ this.homeCoach()?.Name || "-" }}
        </span>
      </div>
    </div>
    <div class="flex flex-col flex-grow gap-5">
      <div class="flex flex-row-reverse gap-2 items-center">
        <img
          alt="photo"
          class="flex-shrink-0 w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15"
          [src]="getAwayImageUrl()"
        />
        <span
          class="font-roboto-600 text-14 max-sm:text-10 truncate whitespace-nowrap overflow-hidden text-ellipsis flex-grow w-0 text-end"
        >
          {{ this.awayCoach()?.Name || "-" }}
        </span>
      </div>
    </div>
  </div>
</div>
